'use client'

import PropTypes from 'prop-types'
import MUIAlert from '@mui/material/Alert'
import MUITypography from '@mui/material/Typography'

export const ValidationErrorAlert = ({ errorCount = 0, isTop = false, validationMessage = null, sx = {} }) => {
  if (!errorCount) return <div data-testid="ValidationErrorAlert" style={{ margin: 0 }} />

  if (validationMessage) {
    return (
      <MUIAlert
        data-testid="ValidationErrorAlert"
        severity="error"
        sx={{
          width: '100%',
          fontSize: '14px',
          justifyContent: 'center',
          color: 'error.dark',
          ...sx
        }}
      >
        {validationMessage.split('\n').map((message) => (
          <MUITypography variant="body1" key={message} color="error.dark" sx={{ mb: 0 }}>
            {message}
          </MUITypography>
        ))}
      </MUIAlert>
    )
  }

  return (
    <MUIAlert
      data-testid="ValidationErrorAlert"
      severity="error"
      sx={{
        width: '100%',
        fontSize: '14px',
        justifyContent: 'center',
        color: 'error.dark',
        '.MuiAlert-message': { mt: '2px' },
        ...sx
      }}
    >
      Please fix the {errorCount === 1 ? 'error' : <strong>{`${errorCount}x errors`}</strong>} shown in red{' '}
      {isTop ? 'below' : 'above'}
    </MUIAlert>
  )
}

ValidationErrorAlert.propTypes = {
  errorCount: PropTypes.number,
  isTop: PropTypes.bool,
  validationMessage: PropTypes.string,
  sx: PropTypes.object
}
